// Резолвер фото одежды через majestic clothesImages/<hash>.webp.
// Хеш модели DLC вычисляется на клиенте GTA-нативом GET_HASH_NAME_FOR_COMPONENT/PROP
// (см. src_client/player/clothesPhoto.js). Здесь — маппинг ItemId→GTA-компонент,
// асинхронный запрос хеша к клиенту (rage-rpc) и сборка URL. Результат кэшируется.
import { executeClientAsync } from 'api/rage'
import PHOTOS from 'json/clothesPhotos.js'
import { clothesCatalog } from 'json/clothes.js'

// ItemId (отрицательные слоты одежды) -> {c: gta component/prop id, p: это prop?}
const MAP = {
    '-1':  { c: 1,  p: false }, // Mask        (component 1)
    '-2':  { c: 2,  p: true  }, // Ears        (prop 2)
    '-3':  { c: 3,  p: false }, // Gloves/Hands(component 3)
    '-4':  { c: 4,  p: false }, // Leg         (component 4)
    '-5':  { c: 5,  p: false }, // Bag         (component 5)
    '-6':  { c: 6,  p: false }, // Feet        (component 6)
    '-7':  { c: 7,  p: false }, // Jewelry     (component 7)
    '-8':  { c: 8,  p: false }, // Undershirt  (component 8)
    '-9':  { c: 9,  p: false }, // BodyArmor   (component 9)
    '-10': { c: 10, p: false }, // Decals      (component 10)
    '-11': { c: 11, p: false }, // Top         (component 11)
    '-12': { c: 0,  p: true  }, // Hat         (prop 0)
    '-13': { c: 1,  p: true  }, // Glasses     (prop 1)
    '-14': { c: 6,  p: true  }, // Watches     (prop 6)
    '-15': { c: 7,  p: true  }, // Bracelets   (prop 7)
}

const BASE = "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/clothesImages/";

const cache = {}; // key -> hex|null

/* Фото по нашей карте — мгновенно, без запроса к клиенту.
   Пол берём из самой вещи (третья часть Data), иначе из персонажа. */
export const clothesMapUrl = (item) => {
    const meta = clothesMeta(item);
    if (!meta || meta.isProp) return null;
    let male = true;
    try {
        const parts = String(item.Data || "").split("_");
        if (parts.length >= 3) male = String(parts[2]).toLowerCase() === "true";
        else if (window.charStore && window.charStore.gender !== undefined) male = !!window.charStore.gender;
    } catch (e) { }
    const box = PHOTOS[(male ? "m" : "f") + meta.component];
    if (!box) return null;
    const list = box[String(meta.drawable)];
    if (!list) return null;
    const hash = list[meta.texture] || list[0];
    return hash ? BASE + hash + ".webp" : null;
}

// ItemId -> раздел каталога (json/clothes.js). Нужен, чтобы перевести ключ вещи
// в настоящий номер модели: у одежды из DLC-паков в каталоге свой id, а drawable
// лежит отдельно в поле Variation. Без перевода фото и натив-хеш ищутся по
// несуществующему номеру и слот остаётся пустым.
const CAT = {
    '-1': "Masks", '-2': "Ears", '-3': "Torsos", '-4': "Legs", '-5': "Bugs",
    '-6': "Shoes", '-7': "Accessories", '-8': "Undershort", '-9': "BodyArmors",
    '-10': "Decals", '-11': "Tops", '-12': "Hat", '-13': "Glasses",
    '-14': "Watches", '-15': "Bracelets",
};

const realDrawable = (item, id) => {
    try {
        const name = CAT[String(item.ItemId)];
        if (!name) return id;
        const parts = String(item.Data || "").split("_");
        let male = true;
        if (parts.length >= 3) male = String(parts[2]).toLowerCase() === "true";
        else if (window.charStore && window.charStore.gender !== undefined) male = !!window.charStore.gender;
        const box = clothesCatalog[male ? "Male" : "Female"];
        const rec = box && box[name] && box[name][String(id)];
        const v = rec && Number(rec.Variation);
        return (v !== undefined && !isNaN(v) && v >= 0) ? v : id;
    } catch (e) { return id; }
}

export const clothesMeta = (item) => {
    if (!item) return null;
    const m = MAP[String(item.ItemId)];
    if (!m) return null;
    const parts = String(item.Data || "").split("_");
    const id = Number(parts[0]) || 0;
    return {
        component: m.c,
        isProp: m.p ? 1 : 0,
        drawable: realDrawable(item, id),
        texture: Number(parts[1]) || 0,
    };
}

// Возвращает Promise<url|null>. null — если не одежда/хеш не получен.
export const clothesHashUrl = async (item) => {
    const meta = clothesMeta(item);
    if (!meta) return null;
    const key = meta.component + "_" + meta.drawable + "_" + meta.texture + "_" + meta.isProp;
    if (cache[key] !== undefined)
        return cache[key] ? BASE + cache[key] + ".webp" : null;
    // rage-rpc ждёт ответа клиента бесконечно: если модуль не ответил (игрок ещё не
    // заспавнен, ped недоступен), слот так и висел бы без картинки. Даём 1.5 секунды,
    // дальше идём по цепочке фолбэков — нарисованная иконка категории.
    let hex = null;
    try {
        hex = await Promise.race([
            executeClientAsync("clothes.photoHash", JSON.stringify(meta)),
            new Promise((resolve) => setTimeout(() => resolve(null), 1500)),
        ]);
    } catch (e) {
        hex = null;
    }
    if (typeof hex === "string") hex = hex.trim();
    if (!hex || hex === "00000000" || hex === "0") hex = null;
    // кэшируем только удачный хеш: неудача могла быть временной (таймаут rpc)
    if (hex) cache[key] = hex;
    return hex ? BASE + hex + ".webp" : null;
}
